import { render, staticRenderFns } from "./AddressField.vue?vue&type=template&id=4aa4e382&scoped=true&"
import script from "./AddressField.vue?vue&type=script&lang=js&"
export * from "./AddressField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa4e382",
  null
  
)

export default component.exports